import React, { useLayoutEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import { CommonToolTip, CstmPagination } from "../../../components/Common/Common";
import { Link, useNavigate } from "react-router-dom";
import { DeleteIcon, EditIcon } from "Assets/icons";
import LoadingOverlay from "components/shared/LoadingOverlay";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { useDeleteServiceStatusMutation, useGetServiceStatusListQuery } from "store/services/serviceStatus";
import { APPOINTMENT_PAYMENT_OPTIONS, CLIENT_TYPE, CLIENT_TYPE_OPTIONS } from "config/constants";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { convertToMomentDate, formatUSD, successMessageToast } from "helpers/common";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { APPOINTMENT_INVOICE_VIEW, SERVICE_STATUS_ADD, SERVICE_STATUS_EDIT } from "config/paths";
import { useDispatch, useSelector } from "react-redux";
import { appointmentInvoicesFilter, serviceStatusFilter } from "store/slices/filter";
import { useGetApptInvoicesListQuery } from "store/services/appointmentInvoices";
import { useSendAppointmentInvoiceMutation, useSendAppointmentRecieptMutation } from "store/services/appointment";
import confirmDialog from "utils/confirmationDialog";

const AppointmentInvoices = () => {

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const filter = useSelector(state => state?.filter?.appointmentInvoicesFilter);

  const [showModal, setShowModal] = useState(false);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [dropdownIndex, setDropdownIndex] = useState(null);

  const [sendInvoice, { isLoading: sendInvoiceLoading }] = useSendAppointmentInvoiceMutation()
  const [sendReciept, { isLoading: sendRecieptLoading }] = useSendAppointmentRecieptMutation()

  const [deleteServiceStatus, { isLoading: deleteLoading }] = useDeleteServiceStatusMutation();
  const { data, isLoading, isError, isFetching } = useGetApptInvoicesListQuery({ page: currentPage, limit: pageSize, ...filter });
  const invoices = data?.rows || [];
  const totalRecords = data?.count || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const handleSendInvoice = async (apptId) => {
    try {
      let isConfirm = await confirmDialog();
      if (!isConfirm) {
        return;
      }

      const data = await sendInvoice({ id: apptId }).unwrap()
      successMessageToast(data?.message)
    } catch (error) {
      console.log("Error sending invoice", error)
    }
  }
  const handleSendReciept = async (apptId) => {
    try {
      let isConfirm = await confirmDialog();
      if (!isConfirm) {
        return;
      }

      const data = await sendReciept({ id: apptId }).unwrap()
      successMessageToast(data?.message)
    } catch (error) {
      console.log("Error sending invoice", error)
    }
  }

  const column = [
    {
      head: "Appointment Title",
      isComponent: true,
      component: (item) => (
        <div className="d-flex align-items-center gap-10">
          <h6 className="m-0 fw-sbold">{item?.invoiceAppointmentAssociation[0]?.title || "--"}</h6>
        </div>
      ),
    },
    {
      head: "Price",
      isComponent: true,
      component: (item) => (
        <div className="d-flex align-items-center gap-10">
          <h6 className="m-0 fw-sbold">{formatUSD(item?.price)}</h6>
        </div>
      ),
    },
    {
      head: "Invoice Date",
      isComponent: true,
      component: (item, ind) => (
        <div className="d-flex align-items-center gap-10">
          <h6 className="m-0 fw-sbold">{item?.invoice_date ? convertToMomentDate(item?.invoice_date) : "--"}</h6>
        </div>
      ),
    },
    {
      head: "Receipt Date",
      isComponent: true,
      component: (item, ind) => (
        <div className="d-flex align-items-center gap-10">
          <h6 className="m-0 fw-sbold">{item?.recipt_date ? convertToMomentDate(item?.recipt_date) : "--"}</h6>
        </div>
      ),
    },
    {
      head: "Payment Status",
      accessor: "payment_status",
      // sorter: true,
      isComponent: true,
      component: (item, ind) => (
        <p
          style={{ width: 80 }}
          className={`${item?.invoiceAppointmentAssociation?.[0]?.payment_status == "success"
            ? "greenStatus"
            : "yellowStatus"
            } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
        >
          {item?.invoiceAppointmentAssociation?.[0]?.payment_status}
        </p>
      ),
    },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item, index) => (
          <div className="ActnBtn d-flex align-items-center gap-10">

          <Dropdown
            onClick={(e) => e.stopPropagation()}
            show={index == dropdownIndex}
            onToggle={() => setDropdownIndex(index == dropdownIndex ? null : index)}
          >
            <Dropdown.Toggle
              variant="transparent"
              className="p-0 border-0 text-dark w-100"
              id="dropdown-basic"
            >
              <span className="icn ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="13"
                  viewBox="0 0 28 13"
                  fill="none"
                >
                  <rect width="28" height="13" rx="6.5" fill="#F2F2F2" />
                  <path
                    d="M23.2678 4.73223C22.2915 3.75592 20.7085 3.75592 19.7322 4.73223C18.7559 5.70854 18.7559 7.29146 19.7322 8.26777C20.7085 9.24408 22.2915 9.24408 23.2678 8.26777C24.2441 7.2915 24.2441 5.70858 23.2678 4.73223Z"
                    fill="#071E3E"
                  />
                  <path
                    d="M16.2678 4.73223C15.2915 3.75592 13.7085 3.75592 12.7322 4.73223C11.7559 5.70854 11.7559 7.29146 12.7322 8.26777C13.7085 9.24408 15.2915 9.24408 16.2678 8.26777C17.2441 7.2915 17.2441 5.70858 16.2678 4.73223"
                    fill="#071E3E"
                  />
                  <path
                    d="M9.26777 4.73223C8.29146 3.75592 6.70854 3.75592 5.73223 4.73223C4.75592 5.70854 4.75592 7.29146 5.73223 8.26777C6.70854 9.24408 8.29146 9.24408 9.26777 8.26777C10.2441 7.2915 10.2441 5.70858 9.26777 4.73223"
                    fill="#071E3E"
                  />
                </svg>
              </span>
            </Dropdown.Toggle>

            <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
              {(item?.recipt_status === "pending" && item?.invoice_pdf) && (
                <Dropdown.Item as={"div"}>
                  <Link
                    to={item?.invoice_pdf}
                    className="themeBlue"
                    target="_blank"
                  >
                    View Invoice
                  </Link>
                </Dropdown.Item>
              )}
              {(item?.recipt_status === "success" && item?.receipt_pdf) && (
                <Dropdown.Item as={"div"}>
                  <Link
                    to={item?.receipt_pdf}
                    className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                    target="_blank"
                  >
                    View Receipt
                  </Link>
                </Dropdown.Item>
              )}
              <Dropdown.Item as={"div"}>
                <Link
                  onClick={() => handleSendInvoice(item?.appointment_id)}
                  className="themeBlue"
                >
                  Send Invoice
                </Link>
              </Dropdown.Item>
              <Dropdown.Item as={"div"}>
                <Link
                  onClick={() => handleSendReciept(item?.appointment_id)}
                  className="themeBlue"
                >
                  Send Receipt
                </Link>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];

  const resetFilter = () => {
    dispatch(appointmentInvoicesFilter({ search: "", status: "", sort: { column: "createdAt", direction: "DESC" } }));
    setCurrentPage(1)
  };

  const handleFilterChange = (key) => (value) => {
    dispatch(appointmentInvoicesFilter({ ...filter, [key]: value }))
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleDelete = async () => {
    try {
      const result = await deleteServiceStatus(currentEntry?.id);
      if (!result?.error) successMessageToast(result?.data?.message);

    } catch (err) { console.error("error delete service status", err); };
  };

  return (
    <>
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={handleDelete}
        type="delete"
      />
      <section className="serviceStatus position-relative py-4">
        <Container fluid={true}>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left">
                  <TableHeader
                    hideStatusFilter
                    heading={"Invoices"}
                    handleFilterChange={handleFilterChange}
                    filter={filter}
                    resetFilter={resetFilter}
                    searchPlaceholder="Search by Appointment"
                    filterComponent={
                      <>
                        <li className="">
                          <Dropdown onSelect={handleFilterChange("status")}>
                            <Dropdown.Toggle
                              variant="transparent"
                              className="border-0 d-flex align-items-center  justify-content-center"
                              id="dropdown-basic"
                            >
                              Payment Status
                              <span className="icn ms-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="8"
                                  viewBox="0 0 12 8"
                                  fill="none"
                                >
                                  <path
                                    d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                    fill="black"
                                  />
                                </svg>
                              </span>
                            </Dropdown.Toggle>

                            <Dropdown.Menu >
                              <Dropdown.Item eventKey={""}>All</Dropdown.Item>
                              {
                                APPOINTMENT_PAYMENT_OPTIONS?.map((item, index) => {
                                  return <Dropdown.Item key={index} eventKey={item.value}>{item?.label}</Dropdown.Item>
                                })
                              }
                            </Dropdown.Menu>
                          </Dropdown>
                        </li>
                      </>
                    }
                  />
                </div>
              </div>
              <div className="table-outer">
                {isLoading ? (
                  <div style={{ height: "200px" }}>
                    <LoadingIndicator />
                  </div>
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching || deleteLoading || sendInvoiceLoading || sendRecieptLoading) && <LoadingOverlay />}
                    <TableLayout
                    // url={'/'}
                      data={invoices}
                      column={column}
                      filter={filter}
                      handleSort={handleFilterChange("sort")}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AppointmentInvoices;
